(function(){
if(window.__wolfQuizMounted)return;
window.__wolfQuizMounted=true;
function init(root){
  if(!root || root.dataset.quizReady) return;
  root.dataset.quizReady='true';
  var sec=root.closest('section');
  var qs=[...root.querySelectorAll('[data-quiz-q]')];
  var res=root.querySelector('[data-quiz-result]');
  var back=root.querySelector('[data-quiz-back]');
  var fill=sec.querySelector('[data-quiz-fill]');
  var progress=fill && fill.parentNode;
  var data=JSON.parse(sec.querySelector('[data-quiz-data]').textContent);
  var step=0, answers=[], started=false, attempt=1, currentResult='';
  var order=['simple','quick','training','carrier','bundle'];
  function track(eventName,detail){
    try{
      var payload={event:eventName,quiz_id:'find-my-vest',quiz_attempt:attempt};
      Object.keys(detail||{}).forEach(function(key){payload[key]=detail[key]});
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push(payload);
    }catch(e){}
    try{if(typeof window.clarity==='function')window.clarity('event',eventName)}catch(e){}
  }
  function show(i,moveFocus){
    step=i;
    qs.forEach((q,k)=>{q.hidden=(k!==i)});
    res.hidden=true;
    back.hidden=(i===0);
    if(fill) fill.style.width=((i+1)/qs.length*100)+'%';
    if(progress){
      progress.setAttribute('aria-valuenow',String(i+1));
      progress.setAttribute('aria-valuetext','Question '+(i+1)+' of '+qs.length);
    }
    if(moveFocus){
      var focusOpt=qs[i].querySelector('.quiz-opt.is-selected')||qs[i].querySelector('.quiz-opt');
      if(focusOpt) {
        focusOpt.focus({preventScroll:true});
        var box=qs[i].getBoundingClientRect();
        var header=document.querySelector('.hdr');
        var top=header?Math.max(0,header.getBoundingClientRect().bottom):0;
        if(box.top<top+16 || box.bottom>innerHeight-16) qs[i].scrollIntoView({block:'center',behavior:'instant'});
      }
    }
  }
  function finish(){
    qs.forEach(q=>q.hidden=true); back.hidden=true;
    var totals={simple:0,quick:0,training:0,carrier:0,bundle:0};
    var eligible=order.slice();
    answers.forEach(function(answer){
      if(answer.eligible.length) eligible=eligible.filter(function(k){return answer.eligible.indexOf(k)!==-1});
      (answer.scores||'').split(',').forEach(function(pair){
        var kv=pair.split(':'); var k=(kv[0]||'').trim(); var v=parseInt(kv[1]||'0',10)||0;
        if(totals[k]!=null) totals[k]+=v;
      });
    });
    totals.bundle=totals.carrier;
    eligible=eligible.filter(function(k){return data[k] && data[k].name && data[k].url && data[k].url.indexOf('/products/')===0});
    var ranked=eligible.sort(function(a,b){return totals[b]-totals[a] || order.indexOf(a)-order.indexOf(b)});
    var best=ranked[0];
    if(!best){
      res.querySelector('[data-quiz-name]').textContent='Let’s compare your options';
      res.querySelector('[data-quiz-why]').textContent='No configured vest meets all these requirements. Compare included weights and capacity before choosing.';
      res.querySelector('[data-quiz-price]').textContent='';
      res.querySelector('[data-quiz-contents]').textContent='';
      res.querySelector('[data-quiz-alternative]').hidden=true;
      res.querySelector('[data-quiz-img]').hidden=true;
      res.querySelector('[data-quiz-shop]').href='/#compare';
      res.querySelector('[data-quiz-shop]').textContent='Compare vests →';
      res.hidden=false;currentResult='';res.querySelector('[data-quiz-name]').focus();return;
    }
    var bestScore=totals[best];
    var d=data[best]||data.carrier;
    currentResult=best;
    var name=res.querySelector('[data-quiz-name]');
    name.textContent=d.name;
    res.querySelector('[data-quiz-why]').textContent=d.available===false?'Currently sold out. View the product for restock options.':d.why;
    res.querySelector('[data-quiz-price]').textContent=d.price;
    res.querySelector('[data-quiz-contents]').textContent=d.contents;
    var alt=res.querySelector('[data-quiz-alternative]');
    alt.replaceChildren();alt.hidden=true;
    var alternative=d.available===false?ranked.find(function(k){return data[k].available===true}):null;
    if(alternative){
      var link=document.createElement('a');link.href=data[alternative].url;link.textContent=data[alternative].name+' · '+data[alternative].price;link.dataset.quizAlternative=alternative;
      alt.append('Available option that meets your requirements: ',link);alt.hidden=false;
    }
    var shop=res.querySelector('[data-quiz-shop]');
    shop.href=d.url||'/collections/plate-carrier';
    shop.textContent=!d.url?'See all vests →':(d.available===false?'View sold-out vest →':'Shop this vest →');
    var img=res.querySelector('[data-quiz-img]');
    if(d.img){img.src=d.img;img.alt=d.name;img.hidden=false;} else {img.removeAttribute('src');img.alt='';img.hidden=true;}
    res.hidden=false;
    if(fill) fill.style.width='100%';
    if(progress){progress.setAttribute('aria-valuenow',String(qs.length));progress.setAttribute('aria-valuetext','Quiz complete');}
    track('wolf_quiz_complete',{quiz_result:best,quiz_product:d.name,quiz_available:d.available!==false,quiz_score:bestScore,quiz_scores:order.map(function(k){return k+':'+totals[k]}).join('|')});
    requestAnimationFrame(function(){name.focus({preventScroll:true});});
  }
  root.addEventListener('click',function(e){
    var opt=e.target.closest('.quiz-opt'); if(opt){
      var revising=answers[step]!=null;
      if(!started){started=true;track('wolf_quiz_start',{});}
      track('wolf_quiz_answer',{quiz_step:step+1,quiz_question:qs[step].querySelector('.quiz-ask').textContent.trim(),quiz_answer:opt.textContent.trim(),quiz_revision:revising});
      qs[step].querySelectorAll('.quiz-opt').forEach(function(button){button.classList.remove('is-selected');button.setAttribute('aria-pressed','false');});
      opt.classList.add('is-selected'); opt.setAttribute('aria-pressed','true');
      answers=answers.slice(0,step); answers[step]={scores:opt.dataset.scores||'',eligible:(opt.dataset.eligible||'').split(',').map(function(k){return k.trim()}).filter(Boolean)};
      if(step<qs.length-1) show(step+1,true); else finish();
      return;
    }
    if(e.target.closest('[data-quiz-back]')){ if(step>0) show(step-1,true); return; }
    if(e.target.closest('[data-quiz-restart]')){track('wolf_quiz_restart',{quiz_result:currentResult});attempt+=1;started=false;currentResult='';answers=[];root.querySelectorAll('.quiz-opt').forEach(function(button){button.classList.remove('is-selected');button.setAttribute('aria-pressed','false');});show(0,true);return;}
    var resultLink=e.target.closest('[data-quiz-shop],[data-quiz-compare],[data-quiz-alternative] a');
    if(resultLink){track('wolf_quiz_result_click',{quiz_result:currentResult,quiz_destination:resultLink.hasAttribute('data-quiz-alternative')?'alternative':resultLink.hasAttribute('data-quiz-shop')?'product':'compare',quiz_available:currentResult&&data[currentResult]?data[currentResult].available!==false:null});}
  });
  show(0,false);
}
function mount(scope){scope.querySelectorAll('[data-quiz]').forEach(init)}
mount(document);
document.addEventListener('shopify:section:load',function(event){mount(event.target)});
})();

